import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormControlServiceBase } from '../types/form-control-service.base';

@Injectable({
  providedIn: 'root'
})
export class PasswordFormControlService implements FormControlServiceBase<'password'> {

  readonly hideTextSubject = new BehaviorSubject<boolean>(true);

  constructor() { }
}
